import { useMutation } from "@apollo/client";
import {
    DELETE_POLICY,
    UPSERT_POLICY,
    DELETE_ACTION_FROM_POLICY,
    ADD_COMPANY_PARENT,
    DELETE_COMPANY_PARENT
} from "graphql/mutations";
import { PolicyActionRef } from "types";

export type DeleteMutationData = {
    deletePolicy: boolean;
};

export type DeleteMutationVariables = {
    policyRelId: string;
};

export type DeleteActionPolicyData = {
    deleteActionFromPolicy: boolean;
};

export type DeleteActionPolicyVariables = {
    policyRelId: string;
    actionId: string;
};
export type UpsertMutationData = {
    addPolicyRel: {
        id: string;
        companySysId: string;
        indexType: string;
        alarmType: string;
        policies: PolicyActionRef[];
    };
};

export type UpsertMutationVariables = {
    policy: {
        id?: string;
        companySysId: string;
        alarmType: string;
        type: string;
        policyId: string;
        policyName: string;
    };
};

export type ManagedCompaniesVariables = {
    companySysId: string;
    companiesChildren: string[];
};

export type addCompanyParentData = {
    addCompanyParent: boolean;
};

export type deleteCompanyParentData = {
    deleteCompanyParent: boolean;
};

export function usePolicyMutations() {
    const deleteMutation = useMutation<DeleteMutationData, DeleteMutationVariables>(DELETE_POLICY, {});

    const updateMutation = useMutation<UpsertMutationData, UpsertMutationVariables>(UPSERT_POLICY, {});

    const deleteActionPolicyMutation = useMutation<DeleteActionPolicyData, DeleteActionPolicyVariables>(
        DELETE_ACTION_FROM_POLICY,
        {
            update: (store, data) => {
                console.log("update data", data);
            },
            onCompleted: (data) => {
                console.log("onCompleted data", data);
            },
            onError: (error) => {
                console.log(error.message);
                throw error;
            }
        }
    );

    const addCompanyParent = useMutation<addCompanyParentData, ManagedCompaniesVariables>(ADD_COMPANY_PARENT, {});

    const deleteCompanyParent = useMutation<deleteCompanyParentData, ManagedCompaniesVariables>(
        DELETE_COMPANY_PARENT,
        {}
    );

    return {
        deleteMutation,
        updateMutation,
        deleteActionPolicyMutation,
        addCompanyParent,
        deleteCompanyParent
    };
}
